import styled from '@emotion/styled';

interface MatterportBlockDeltaProps {
	url: string;
	index?: number;
}

const Wrapper = styled.section`
	padding: 3rem 1.5rem 4rem;
`;

const Title = styled.h2`
	text-transform: uppercase;
	font-size: 2rem;
	letter-spacing: 0.2em;
	margin-bottom: 1.5rem;
`;

const Frame = styled.iframe`
	width: 100%;
	aspect-ratio: 16 / 9;
	border: none;
`;

export default function MatterportBlockDelta({ url, index }: MatterportBlockDeltaProps) {
	return (
		<Wrapper id={index == null ? 'tours' : undefined}>
			<Title>3D Tour</Title>
			<Frame src={url} allowFullScreen allow="xr-spatial-tracking" />
		</Wrapper>
	);
}
